import React, { useCallback } from 'react';
import { LinkV2 } from '@withjoy/joykit';
import { Link as RL } from '@react-router';
import { pxToRem } from '@withjoy/joykit/theme';
import { Category } from '@graphql/generated-base';
/** TODO: Need to move GuestSiteTypographyOverride to shared and refactor the usage of it in the guest site
 * https://withjoy.atlassian.net/browse/PRNT-3794
 */
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { body2ToParagraphOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';
import { useScaleGuestSiteFontSize } from '@shared/core/website/theming/useScaleGuestSiteFontSize';
import { StyledBoxViewDetails, StyledBoxText, StyledBoxArrow, StyledBoxArrowIcon } from './ViewDetailsArrow.styles';
import type { ViewDetailsArrowProps } from './ViewDetailsArrow.types';
import { useTranslation } from '@shared/core';

/**
 * ViewDetailsArrow - Animated arrow component that appears below RSVP buttons
 * to guide users to view more details on the next page.
 *
 * Only shown on Aloha layout on desktop devices.
 *
 * @param show - Controls visibility with fade in/out animation
 * @param eventHandle - Event handle for navigation
 * @param nextPageSlug - Slug of the next page to navigate to
 * @param queryString - Optional query string to append to navigation
 * @param onViewDetailsButtonClicked - Optional callback when arrow is clicked
 */
export const ViewDetailsArrow: React.FC<ViewDetailsArrowProps> = ({ show, eventHandle, nextPageSlug, queryString, onViewDetailsButtonClicked }) => {
  const { tq } = useTranslation('guestSiteWelcome');
  const { scaleFontSize } = useScaleGuestSiteFontSize();

  const handleViewDetailsButton = useCallback(() => {
    if (onViewDetailsButtonClicked) {
      onViewDetailsButtonClicked();
    }
  }, [onViewDetailsButtonClicked]);

  return (
    <StyledBoxViewDetails show={show}>
      <LinkV2
        onClick={handleViewDetailsButton}
        as={RL}
        to={`/${eventHandle}/${nextPageSlug}${queryString || ''}`}
        color={'inherit'}
        _visited={{ color: 'inherit' }}
        _hover={{ color: 'inherit' }}
        _active={{ color: 'inherit' }}
        textAlign="center"
        textDecoration="none"
      >
        <GuestSiteTypographyOverride override={body2ToParagraphOverride}>
          <StyledBoxText style={{ fontSize: scaleFontSize(pxToRem(15), Category.PARAGRAPH) }}>{tq`View Details`}</StyledBoxText>
        </GuestSiteTypographyOverride>
        <StyledBoxArrow>
          <StyledBoxArrowIcon />
        </StyledBoxArrow>
      </LinkV2>
    </StyledBoxViewDetails>
  );
};

ViewDetailsArrow.displayName = 'ViewDetailsArrow';
